module.exports = __webpack_public_path__ + "fax@2x.png?cfaf7d6d0423dd301801889bd7f40b4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fax@2x.png
// module id = 31
// module chunks = 0